import { motion } from "framer-motion";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  const activities = [
    "Playing Call of Duty Mobile",
    "Writing Tech Blogs",
    "Travelling",
  ];

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="glass-effect rounded-xl p-8 shadow-xl shadow-purple-500/10"
    >
      <div className="space-y-6 text-gray-300">
        <p className="text-base leading-relaxed">
          Hi Everyone, I am{" "}
          <span className="text-purple-400 font-semibold">
            Benedict Kpaduwa
          </span>{" "}
          from{" "}
          <span className="text-purple-400 font-semibold">
            Calgary, Alberta, Canada
          </span>
          .
        </p>

        <p className="text-base leading-relaxed">
          I'm a creative full stack and mobile applications developer with
          experience in a variety of exciting projects. A level head and
          rational approach to problem solving combined with a passion for
          innovative and fresh ideas has led to a portfolio of impressive
          website solutions. Technically competent and industry aware means that
          each project is undertaken with the most up-to-date and relevant
          programming foundations available. A strong communicator with the
          ability to convey ideas clearly with an emphasis on client
          satisfaction.
        </p>

        <div>
          <p className="text-lg font-semibold mb-4 text-white">
            Apart from coding, some other activities that I love to do!
          </p>
          <ul className="space-y-3">
            {activities.map((activity, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center gap-3 text-base"
              >
                <ImPointRight className="text-purple-400 flex-shrink-0" />
                <span>{activity}</span>
              </motion.li>
            ))}
          </ul>
        </div>

        <div className="pt-6 border-t border-purple-900/30">
          <p className="text-purple-300 italic text-lg mb-2">
            "Strive to build things that make a difference!!"
          </p>
          <p className="text-gray-400 text-sm">— Benedict</p>
        </div>
      </div>
    </motion.div>
  );
}

export default AboutCard;
